module.exports = __webpack_public_path__ + "img/eye-close.d1d8b43e.svg";